/**
 * Configuration constants
 */

/**
 * Breakpoint for desktop layout (≥900px)
 * @type {number}
 */
export const DESKTOP_BREAKPOINT = 900;

/**
 * Rewind/forward skip duration in seconds
 * @type {number}
 */
export const REWIND_SECONDS = 10;

/**
 * Maximum number of transcript HTML caches to store
 * @type {number}
 */
export const TRANSCRIPT_CACHE_LIMIT = 10;

/**
 * Maximum highlight updates per second (for performance)
 * @type {number}
 */
export const SENTENCE_HIGHLIGHT_FPS = 5;

/**
 * Transcript auto-follow scroll mode
 * @type {string}
 */
export const TRANSCRIPT_SCROLL_MODE = 'lyrics_v1';

/**
 * Vertical offset for transcript centering in pixels
 * @type {number}
 */
export const TRANSCRIPT_CENTER_OFFSET_PX = 0;

/**
 * Scroll animation duration in milliseconds
 * @type {number}
 */
export const TRANSCRIPT_SCROLL_DURATION_MS = 260;

/**
 * Maximum number of events to store in the ring buffer
 * @type {number}
 */
export const EVENT_BUFFER_SIZE = 500;

/**
 * First listen completion detection threshold in seconds
 * Audio is considered "near end" when within this many seconds of completion
 * @type {number}
 */
export const FIRST_LISTEN_END_THRESHOLD = 0.5;
